import { render, staticRenderFns } from "./appointment-item.vue?vue&type=template&id=2886e5de"
import script from "./appointment-item.vue?vue&type=script&lang=js"
export * from "./appointment-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports